import styled from 'styled-components/macro'

/** TOD: Refactor AccordionBody, DatePicker: calendar is not shown if overflow is not initial on parent **/
export const AccordionBodyWrapper = styled.div`
  > section {
    overflow: ${({ $overflow }: { $overflow: string }) => $overflow};
  }
`
